export default __webpack_public_path__ + "static/media/bricks.50aa924e.jpg";